import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { AddUnitMeasurementListPayloadType, UpdateUnitsMeasermentPayloadType } from '../../../../commonTypes/clientSettingsTypes';
import { UNIQUE_QUANTITY_CODES_LIST } from '../../../../constant/uniqueQuantityCodeConstants';
import { UnitOfMeasurementDataType } from '../../../../redux/clientSettings/clientSettingTypes';
import { RootState } from '../../../../redux/rootReducers';
import { DropDown } from '../../../commons';

type UnitsMeasurmentErrorType = {
  formalNameError: string,
  symbolError: string,
  decimalError: string,
  unitsMeasurmentError: string
};

type AppProps = {
  toggleAddEditUnitOfMeasurementModal: () => void;
  isOpen: boolean;
  isEdit?: boolean;
  client_code: number | undefined;
  unitOfMeasurementData: UnitOfMeasurementDataType;
  setUnitOfMeasurementData: (data: any) => void;
  setUniqueQuantityCode: (data: any) => void;
  uniqueQuantityCode?: any;
  handleAddUnitsMeasurment: (data: AddUnitMeasurementListPayloadType) => void;
  editAccountDetailsData?: any;
  handleResetEditData: () => void;
  handleEditUnitsMeasermentDetails: (data: UpdateUnitsMeasermentPayloadType) => void;
};

const AddEditUnitOfMeasurementModal = ({
  toggleAddEditUnitOfMeasurementModal,
  unitOfMeasurementData,
  setUnitOfMeasurementData,
  uniqueQuantityCode,
  setUniqueQuantityCode,
  isOpen,
  isEdit,
  client_code,
  handleAddUnitsMeasurment,
  editAccountDetailsData,
  handleResetEditData,
  handleEditUnitsMeasermentDetails
}: AppProps) => {
  const token = useSelector((state: RootState) => state.auth.token);
  const [unitsDetailsError, setUnitsDetailsError] =
    useState<UnitsMeasurmentErrorType>({
      formalNameError: '',
      symbolError: '',
      decimalError: '',
      unitsMeasurmentError: ''
    });

  const { formalNameError, symbolError, decimalError, unitsMeasurmentError } = unitsDetailsError;
  useEffect(() => {
    if (isEdit) {
      setUnitOfMeasurementData((prev: any) => ({
        ...prev,
        formalName: editAccountDetailsData?.stock_unit_name,
        numOfDecimalPlaces: editAccountDetailsData?.no_of_decimal_places.toString(),
        symbol: editAccountDetailsData?.stock_unit_symbol,
        uqc: editAccountDetailsData?.unique_quantity_code.label
      }))
      setUniqueQuantityCode((prev: any) => ({
        ...prev,
        value: editAccountDetailsData?.stock_unit_symbol,
        label: editAccountDetailsData?.unique_quantity_code.label,
      }))
    }
    //eslint-disable-next-line
  }, [isEdit])

  const handleUnitOfMeasurementData = (mode: any) => {
    setUnitOfMeasurementData((prv: any) => ({
      ...prv,
      symbol: mode?.value
    }))
    setUniqueQuantityCode({
      value: mode?.value,
      label: mode?.label
    })

    setUnitsDetailsError((prev: any) => ({
      ...prev,
      unitsMeasurmentError: '',
      symbolError: ''
    }))
  }
  const handleUnitsDetailsChange = (e: any) => {
    let targetName = e.target.name;
    if (targetName === 'formalName' && e?.target.value.length >= 0) {
      setUnitOfMeasurementData((prv: any) => ({
        ...prv,
        formalName: e?.target.value
      }))
      setUnitsDetailsError((prev: any) => ({
        ...prev,
        formalNameError: ''
      }))
    }
    else if (targetName === 'decimalPlaces' && e.target.value >= 0 && e.target.value <= 9) {
      setUnitOfMeasurementData((prv: any) => ({
        ...prv,
        numOfDecimalPlaces: e?.target.value.toString()
      }))
      setUnitsDetailsError((prev: any) => ({
        ...prev,
        decimalError: ''
      }))
    }
    else if (targetName === 'decimalPlaces' && e.target.value < 0 && e.target.value > 9) {
      setUnitsDetailsError((prev: any) => ({
        ...prev,
        decimalError: 'Please chose between 0 to 9'
      }))
    }

  }

  //Add and Edit Units Measurement
  const addUnitMeasermentData = () => {
    if (unitOfMeasurementData?.formalName.trim().length && unitOfMeasurementData?.symbol.length && unitOfMeasurementData?.numOfDecimalPlaces?.toString()) {
      if (isEdit) {
        let finaEditData = {
          ...editAccountDetailsData,
          stockUnitId: editAccountDetailsData?.stock_unit_id,
          stockUnitName: unitOfMeasurementData?.formalName.trim(),
          numOfDecimalPlaces: unitOfMeasurementData?.numOfDecimalPlaces,
          stockUnitSymbol: unitOfMeasurementData?.symbol,
          uniqueQuantityCode: {
            value: uniqueQuantityCode?.value,
            label: uniqueQuantityCode?.label
          }
        }
        handleEditUnitsMeasermentDetails(finaEditData);
      }
      else {
        let finalData = {
          token,
          client_code: client_code,
          stockUnitName: unitOfMeasurementData?.formalName.trim(),
          stockUnitSymbol: unitOfMeasurementData?.symbol,
          numOfDecimalPlaces: unitOfMeasurementData?.numOfDecimalPlaces?.toString(),
          uniqueQuantityCode: {
            value: uniqueQuantityCode?.value,
            label: uniqueQuantityCode?.label
          }
        }
        handleAddUnitsMeasurment(finalData)
        toggleAddEditUnitOfMeasurementModal()

      }
    }
    else {
      if (!unitOfMeasurementData?.numOfDecimalPlaces && unitOfMeasurementData?.numOfDecimalPlaces !== 0) {
        setUnitsDetailsError((prev) => ({
          ...prev,
          ...(!unitOfMeasurementData?.numOfDecimalPlaces && {
            decimalError: "Please Put a Number Between 0 to 9",
          }),
        }))
      }
      if (unitOfMeasurementData?.formalName.trim().length == 0) {
        setUnitsDetailsError((prev) => ({
          ...prev,
          formalNameError: "Formal Name is required!",
        }))
      }
      setUnitsDetailsError((prev) => ({
        ...prev,
        ...(!uniqueQuantityCode?.value.length && {
          unitsMeasurmentError: "Please choose Units",
        }),
        ...(!unitOfMeasurementData?.formalName && {
          formalNameError: "Formal Name is required!",
        })
      }))
    }


  }

  return (
    <Modal isOpen={isOpen} toggle={toggleAddEditUnitOfMeasurementModal} size="lg">
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} Unit of Measurement`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4" style={{ paddingLeft: "40px" }}>
        <>
          <div style={{ width: '53%' }}>
            <form>
              <div className="form-group mt-3">
                <div>
                  <label htmlFor="uqc"
                    className={unitOfMeasurementData?.uqc ? "active" : ""}
                  >UQC (Unqiue Quantity Code)*</label>
                  <DropDown
                    options={UNIQUE_QUANTITY_CODES_LIST}
                    value={uniqueQuantityCode}
                    handleChange={handleUnitOfMeasurementData}
                  />
                  <small className="text-danger">{unitsMeasurmentError}</small>
                </div>
              </div>
            </form>
          </div>
          <form>
            <div className="form-group mt-3">
              <div style={{ width: "53%" }}>
                <label
                  htmlFor="symbol"
                  className={unitOfMeasurementData?.symbol ? "active" : ""}
                >
                  Symbol
                </label>
                <input
                  type="text"
                  className={`form-control ${!!symbolError ? "error-border" : null
                    }`}
                  name="symbol"
                  value={unitOfMeasurementData?.symbol}
                  disabled
                  maxLength={150}
                />
              </div>
              {!!symbolError && (
                <small className="text-danger">{symbolError}</small>
              )}
            </div>
          </form>
          <form>
            <div className="form-group mt-3">
              <div style={{ width: "53%" }}>
                <label
                  htmlFor="formalName"
                  className={unitOfMeasurementData?.formalName ? "active" : ""}
                >
                  Formal Name*
                </label>
                <input
                  type="text"
                  className={`form-control ${!!formalNameError ? "error-border" : null
                    }`}
                  name="formalName"

                  value={unitOfMeasurementData?.formalName}
                  onChange={(e) => handleUnitsDetailsChange(e)}
                  maxLength={150}
                />
              </div>
              {!!formalNameError && (
                <small className="text-danger">{formalNameError}</small>
              )}
            </div>
          </form>
          <form>
            <div className="form-group mt-3">
              <div style={{ width: "53%" }}>
                <label
                  htmlFor="decimalNumber"
                  className={unitOfMeasurementData?.numOfDecimalPlaces ? "active" : ""}
                >
                  No. of Decimal Places (0-9)
                </label>
                <input
                  type="number"
                  className={`form-control ${!!decimalError ? "error-border" : null
                    }`}
                  name="decimalPlaces"
                  value={unitOfMeasurementData?.numOfDecimalPlaces}
                  onChange={(e) => handleUnitsDetailsChange(e)}
                  onWheel={event => event.currentTarget.blur()}
                />
                {!!decimalError && (
                  <small className="text-danger">{decimalError}</small>
                )}
              </div>
            </div>
          </form>
        </>
      </ModalBody>
      <ModalFooter>
        <span
          className="pointer"
          onClick={() => {
            handleResetEditData()
            toggleAddEditUnitOfMeasurementModal();
          }}
        >
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => { addUnitMeasermentData() }}
          disabled={!uniqueQuantityCode || !unitOfMeasurementData?.formalName}
        >
          {isEdit ? "Update Details" : "Add Details"}
        </Button>
      </ModalFooter>
    </Modal>
  )
};

export default AddEditUnitOfMeasurementModal;